import React from 'react'
import ProductCard from '../ProductCard'
import reagents from '../../assets/reagents.webp'
import flu from '../../assets/flu.jpeg'
import test from '../../assets/test.webp'
import edta from '../../assets/edta.jpeg'
import clot from '../../assets/CLOT.jpeg'
import cent from '../../assets/cejt.jpeg'

    const data = [
        {
            id: 1,
            name: 'Reagents',
            imgSrc: reagents,
        },
        {
            id: 2,
            name: 'Test kits & Analyzers',
            imgSrc: flu,
        },
        {
            id: 3,
            name: 'Test Tubes',
            imgSrc: test,
        },
        {
            id: 4,
            name: 'EDTA Tube',
            imgSrc: edta,
        },
        {
            id: 5,
        name: 'VacuLab® Clot Activator Tube',
            imgSrc: clot,
        },
        {
            id: 6,
            name: 'Medical Centrifuge',
            imgSrc: cent,
        },
    ]

export default function Card3() {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {data.map((item, index) => (
                <ProductCard key={item.id} product={item} index={index} />
            ))}
        </div>
    )
}
